import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
// moment
import moment from "moment";
moment.locale("pt-br");

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [{
      path: "*",
      component: () => import("../components/general/ErrorPage.vue")
    },
    {
      path: "/",
      name: "Home",
      component: () => import("../components/meals/MealPlan.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/download",
      name: "Download",
      component: () => import("../components/general/DownloadPage.vue")
    },
    {
      path: "/change-email",
      name: "Change Email",
      component: () => import("../components/accounts/ChangeEmail.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/change-name",
      name: "Change Name",
      component: () => import("../components/accounts/ChangeName.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/change-password",
      name: "Change Password",
      component: () => import("../components/accounts/ChangePassword.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/change-phone",
      name: "Change Phone",
      component: () => import("../components/accounts/ChangePhone.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/forgot-password",
      name: "Forgot Password",
      component: () => import("../components/accounts/ForgotPassword.vue"),
      meta: {
        loggedOutOnly: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../components/accounts/LoginUser.vue"),
      meta: {
        loggedOutOnly: true
      }
    },
    {
      path: "/onboarding/body",
      name: "Onboarding: Body",
      component: () => import("../components/accounts/OnboardingBody.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/onboarding/diet",
      name: "Onboarding: Diet",
      component: () => import("../components/accounts/OnboardingDiet.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/onboarding/goal",
      name: "Onboarding: Goal",
      component: () => import("../components/accounts/OnboardingGoal.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/onboarding/restrictions",
      name: "Onboarding: Restrictions",
      component: () =>
        import("../components/accounts/OnboardingRestrictions.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reset-password",
      name: "Reset Password",
      component: () => import("../components/accounts/ResetPassword.vue"),
      meta: {
        loggedOutOnly: true
      }
    },
    {
      path: "/signup",
      name: "Sign Up",
      component: () => import("../components/accounts/SignupUser.vue"),
      meta: {
        loggedOutOnly: true
      }
    },
    {
      path: "/subscribe",
      name: "Subscribe",
      component: () => import("../components/accounts/SubscribePage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/welcome",
      name: "Welcome",
      component: () => import("../components/accounts/WelcomePage.vue"),
      meta: {
        loggedOutOnly: true
      }
    },
    {
      path: "/my-dishes",
      name: "My Dishes",
      component: () => import("../components/general/DishList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/filter",
      name: "Filter Recipes",
      component: () => import("../components/general/FilterRecipes.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/legal",
      name: "Legal",
      component: () => import("../components/general/LegalDocuments.vue")
    },
    {
      path: "/my-diet",
      name: "My Diet",
      component: () => import("../components/general/MyDiet.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/recipes",
      name: "Recipe Book",
      component: () => import("../components/general/RecipeBook.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/report-weight",
      name: "Report Weight",
      component: () => import("../components/general/ReportWeight.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/support",
      name: "Support",
      component: () => import("../components/general/SupportPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/profile",
      name: "Profile",
      component: () => import("../components/general/UserProfile.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/settings",
      name: "Settings",
      component: () => import("../components/general/UserSettings.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/alternatives/:mealplanId",
      name: "Alternative Meals",
      component: () => import("../components/meals/AlternativeMeals.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/alternative/:mealplanId/:dishId/:proportion",
      name: "Alternative Meal",
      component: () => import("../components/meals/MealInfo.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/beverages/:meal",
      name: "Beverages",
      component: () => import("../components/meals/BeveragesPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/desserts/:meal",
      name: "Desserts",
      component: () => import("../components/meals/DessertsPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/body",
      name: "Edit Body",
      component: () => import("../components/meals/EditBody.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/diet",
      name: "Edit Diet",
      component: () => import("../components/meals/EditDiet.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/goal",
      name: "Edit Goal",
      component: () => import("../components/meals/EditGoal.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/preferences",
      name: "Edit Preferences",
      component: () => import("../components/meals/EditPreferences.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/restrictions",
      name: "Edit Restrictions",
      component: () => import("../components/meals/EditRestrictions.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/goal",
      name: "Goal",
      component: () => import("../components/meals/GoalPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/meal/:mealplanId/:meal/:dishId/:proportion",
      name: "Meal",
      component: () => import("../components/meals/MealInfo.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/favorite/meal/:dishId/:proportion",
      name: "Favorite Meal",
      component: () => import("../components/meals/MealInfo.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/recipe/:dishId/:proportion",
      name: "Recipe",
      component: () => import("../components/meals/MealInfo.vue")
    },
    {
      path: "/shopping-list",
      name: "Shopping List",
      component: () => import("../components/meals/ShoppingList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/shopping",
      name: "Shared Shopping List",
      component: () => import("../components/meals/ShoppingList.vue")
    },
    {
      path: "/meals",
      name: "Meal Plan",
      component: () => import("../components/meals/MealPlan.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/meals/:day",
      name: "Meal Plan: Day",
      component: () => import("../components/meals/MealPlan.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    let user = firebase.auth().currentUser;
    if (user) {
      next();
    } else {
      next({
        name: "Welcome"
      });
    }
  } else if (to.matched.some(rec => rec.meta.loggedOutOnly)) {
    let user = firebase.auth().currentUser;
    const today = moment();
    const day = moment(today).format("DD-MM-YYYY");
    if (user) {
      next({
        name: "Meal Plan: Day",
        params: {
          day: day
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;